/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonPrimary } from '../../../utils/Button';
import { GetDate } from '../../../utils/Show';
import { mkRelativeUrl } from '../../../utils/URL';
import cn from '../../../utils/cn';
import { useCustomer } from '../CustomerProvider';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const navigate = useNavigate();
    const [isTrActive, setIsTrActive] = useState(false);
    const {
        handleCustomerTypeModal,
        handleCustomerStatusModal,
        handleShowEditModal,
        handleChangeCurrencyModal
    } = useCustomer();
    const handleRedirect = (e) => {
        e.stopPropagation();
        navigate(mkRelativeUrl(`/customers/${item?.id}/info`));
    };
    // const isActive = item?.status === 'active';
    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.organization}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1 capitalize">{item?.role}</span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard name="Role" value={item?.role} isCapitalize className="sm:hidden" />
                <TableInfoCard name="Email" value={item?.primaryEmail} />
                {/* application list */}
                <div className="text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5">
                    <div className="inline-flex justify-between items-center min-w-[112px] w-28">
                        <span>Application</span>
                        <span>:</span>
                    </div>
                    <div className="flex flex-row relative customer_apps h-full w-full">
                        {item?.subscriptions?.length !== 0 ? (
                            item?.subscriptions?.map((app, index) => (
                                <img
                                    key={app.id}
                                    data-tooltip-id="myToolTip"
                                    data-tooltip-content={app.subscriptionName}
                                    src={app.logoUrl}
                                    alt={app.name}
                                    onClick={() =>
                                        navigate(
                                            mkRelativeUrl(`/subscriptions/manage/${app?.id}/info`)
                                        )
                                    }
                                    className={`w-[25px] absolute top-1/2 -translate-y-1/2 rounded-full border-2 cursor-pointer bg-white border-white app-${
                                        index + 1
                                    }`}
                                />
                            ))
                        ) : (
                            <span className="text-primary font-normal text-sm">------</span>
                        )}

                        {item?.subscriptions?.length >= 5 && (
                            <span
                                data-tooltip-id="myToolTip"
                                data-tooltip-content={`${item.subscriptions.length - 3} more`}
                                className="flex flex-row items-center justify-center w-8 h-8 text-white absolute top-1/2 text-sm font-medium -translate-y-1/2 left-18 rounded-full border-2 border-white bg-[#1B1B1F]/60 cursor-pointer z-10"
                            >
                                +{item.subscriptions.length - 3}
                            </span>
                        )}
                    </div>
                </div>
                <TableInfoCard
                    name="Date Created"
                    value={GetDate(item?.timeCreated)}
                    isCapitalize
                />
                <TableInfoCard
                    name="2FA"
                    value={
                        item?.tfaEnabled ? (
                            <span className="text-success">Enabled</span>
                        ) : (
                            <span className="text-error">Disabled</span>
                        )
                    }
                />
                <TableInfoCard
                    name="User Status"
                    value={
                        item?.status ? (
                            <span className="text-success">{item?.status}</span>
                        ) : (
                            <span className="text-error">{item?.status}</span>
                        )
                    }
                    isCapitalize
                />

                <div className="flex flex-row flex-wrap gap-px justify-end items-center">
                    <ButtonPrimary
                        btnType="button"
                        title="Edit"
                        onClick={(ev) => handleShowEditModal(ev, item)}
                    />
                    <ButtonPrimary
                        btnType="button"
                        title="Change Currency"
                        onClick={(ev) => handleChangeCurrencyModal(ev, item)}
                    />
                    <ButtonPrimary
                        btnType="button"
                        title="Change Role"
                        onClick={(ev) => handleCustomerTypeModal(ev, item)}
                    />

                    <ButtonPrimary
                        btnType="button"
                        title={item?.status === 'active' ? 'Make Inactive' : 'Make Active'}
                        onClick={(ev) => handleCustomerStatusModal(ev, item)}
                    />
                    <ButtonPrimary btnType="button" title="Manage" onClick={handleRedirect} />
                </div>
            </div>
        </div>
    );
}

function PageTableMobile({ data }) {
    return (
        <div className="customer_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data?.customers && data?.customers?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.customers?.map((item) => <TableRow key={item.id} item={item} />)
                )}
            </div>
        </div>
    );
}

export default PageTableMobile;
